import { render } from "./DownloadFileList.vue?vue&type=template&id=033a801a&scoped=true"
import script from "./DownloadFileList.vue?vue&type=script&lang=js"
export * from "./DownloadFileList.vue?vue&type=script&lang=js"

import "./DownloadFileList.vue?vue&type=style&index=0&id=033a801a&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/build_logistics-fe-ntp-hz_a3ee6c512411489faef2ecfce652dcca/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033a801a"]])

export default __exports__